const MS4s = () => {
  const MS4sData = [
    {
      agency: 'Arapahoe County',
      total_construction_sites: '47',
      construction_inspections_count: '779',
      construction_site_enforcement_actions: '5<sup>7</sup>',
      permanent_bmps_count: '64<sup>8</sup>',
      new_permanent_bmps_count: '5',
      inspections: '11<sup>9</sup>',
      flood_control_facilities: 'NR',
    },
    {
      agency: 'Douglas County',
      total_construction_sites: '1444',
      construction_inspections_count: '7156',
      construction_site_enforcement_actions: '166<sup>3</sup>',
      permanent_bmps_count: '175',
      new_permanent_bmps_count: '5',
      inspections: '152',
      flood_control_facilities: '--',
    },
    {
      agency: 'City of Aurora',
      total_construction_sites: '76',
      construction_inspections_count: '473',
      construction_site_enforcement_actions: '6',
      permanent_bmps_count: '29',
      new_permanent_bmps_count: '2',
      inspections: '27',
      flood_control_facilities: '27',
    },
    {
      agency: 'SEMSWA (City of Centennial)',
      total_construction_sites: '77',
      construction_inspections_count: '1277',
      construction_site_enforcement_actions: '38<sup>7</sup>',
      permanent_bmps_count: '104<sup>8</sup>',
      new_permanent_bmps_count: '2',
      inspections: '18<sup>9</sup>',
      flood_control_facilities: 'NR',
    },
    {
      agency: 'City of Greenwood Village',
      total_construction_sites: '0',
      construction_inspections_count: '0',
      construction_site_enforcement_actions: '0',
      permanent_bmps_count: '29',
      new_permanent_bmps_count: '0',
      inspections: '6',
      flood_control_facilities: '6',
    },
    {
      agency: 'City of Lone Tree',
      total_construction_sites: '16',
      construction_inspections_count: '144',
      construction_site_enforcement_actions: '0',
      permanent_bmps_count: '20',
      new_permanent_bmps_count: '0',
      inspections: '20',
      flood_control_facilities: '0',
    },
    {
      agency: 'City of Castle Pines',
      total_construction_sites: '46',
      construction_inspections_count: '628',
      construction_site_enforcement_actions: '8',
      permanent_bmps_count: '17',
      new_permanent_bmps_count: '14',
      inspections: '39',
      flood_control_facilities: '0',
    },
    {
      agency: 'Town of Castle Rock',
      total_construction_sites: '1284',
      construction_inspections_count: '3035',
      construction_site_enforcement_actions: '1515<sup>4</sup>',
      permanent_bmps_count: '122',
      new_permanent_bmps_count: '22',
      inspections: '254',
      flood_control_facilities: '156<sup>5</sup>',
    },
    {
      agency: 'Town of Parker',
      total_construction_sites: '103',
      construction_inspections_count: '1372',
      construction_site_enforcement_actions: '22',
      permanent_bmps_count: '179',
      new_permanent_bmps_count: '19',
      inspections: '405',
      flood_control_facilities: '382<sup>6</sup>',
    },
    {
      agency: 'CDOT',
      total_construction_sites: '2<sup>1</sup>',
      construction_inspections_count: '16<sup>2</sup>',
      construction_site_enforcement_actions: '0',
      permanent_bmps_count: '52',
      new_permanent_bmps_count: '0',
      inspections: '24',
      flood_control_facilities: '0',
    },
  ];

  // Declare and configure request overview table
  const MS4sTable = new requestTable({
    container: '#ms4s-table',
    filterEnabled: false,
    tableHeaders: {
      agency: 'Agency',
      total_construction_sites: 'Total Construction Sites',
      construction_inspections_count: 'Construction Inspections',
      construction_site_enforcement_actions: 'Construction Site Enforcement Actions',
      permanent_bmps_count: 'Permanent BMPs',
      new_permanent_bmps_count: 'New Permanent BMPs',
      inspections: 'Inspections',
      flood_control_facilities: 'Flood Control Facilities',
    },
    tableActions: [],
    tableData: MS4sData,
  });
  MS4sTable.buildTable();
};
